import { render, staticRenderFns } from "./ModalCTRestrictions.vue?vue&type=template&id=cf28619c&"
import script from "./ModalCTRestrictions.vue?vue&type=script&lang=js&"
export * from "./ModalCTRestrictions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports